import { createContext, ReactNode } from 'react';

// Define the structure of the user data
export interface User {
    id: string;
    name: string;
    email: string;
    token: string;
}

// Define the context value types
export interface AuthContextType {
    user: User | null;
    login: (userData: User) => void;
    logout: () => void;
}

// Define props for the AuthProvider
export interface AuthProviderProps {
    children: ReactNode; // Ensures children can be any valid ReactNode
}

// Create the AuthContext with an undefined initial value
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

